<template>
  <div>
    <Header v-bind:HeaderCheck = "HeaderCheck"></Header>
    <div id="layerslider">
      <!--layer slider starts-->
      <div class="slider-shadow-top">
      </div>
      <div class="slider-shadow-bottom">
      </div>
      <div class="ls-layer" style="slidedirection: top; slideoutdirection : top; slidedelay: 6000; durationin: 1500; durationout: 1500; delayout: 500;">
        <img src="static/img/homebanner/bg2.png" class="ls-bg" alt="">
<!--        <img src="static/images/slider/layer/1/-1.png" class="ls-s6" alt="" style="top: 10px; left: -15px; slidedirection : bottom; slideoutdirection : bottom; durationin : 1500; durationout : 750; easingin : easeInOutQuint; easingout : easeInOutQuint; delayin : 600;">-->
        <h1 class="ls-s3 ls_large_text_01" style="position: absolute; top:150px; right: 490px; slidedirection : top; slideoutdirection : top; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 1000;">
          {{$t('home.bannerText.tip1.h1')}}
        </h1>
        <h4 class="ls-s3 l1-s1 ls_large_text_02" style="position: absolute; top:210px; right: 490px; slidedirection : bottom; slideoutdirection : bottom; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 1000;">
          {{$t('home.bannerText.tip1.h4')}}
        </h4>
        <img src="static/img/homebanner/img_bluetooth.png" class="ls-s3" style="position: absolute; top:240px; right: 490px; slidedirection : bottom; slideoutdirection : bottom; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInOutQuint; delayin : 1100;"/>
        <h4 class="ls-s3 l1-s1 ls_large_text_02" style="position: absolute; top:310px; right: 490px; slidedirection : bottom; slideoutdirection : bottom; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 1000;">
          {{$t('home.bannerText.tip1.h42')}}
        </h4>
      </div>
      <div class="ls-layer" style="slidedirection: top; slideoutdirection : top; slidedelay: 6000; durationin: 1500; durationout: 1500; delayout: 500;">
        <img src="static/img/homebanner/bg1.png" class="ls-bg" alt="">
        <!--        <img src="static/images/slider/layer/1/-1.png" class="ls-s6" alt="" style="top: 10px; left: -15px; slidedirection : bottom; slideoutdirection : bottom; durationin : 1500; durationout : 750; easingin : easeInOutQuint; easingout : easeInOutQuint; delayin : 600;">-->
        <h1 class="ls-s3 ls_large_text_01" style="position: absolute; top:150px; right: 490px; slidedirection : top; slideoutdirection : top; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 1000;">
          {{$t('home.bannerText.tip2.h1')}}
        </h1>
        <h4 class="ls-s3 l1-s1 ls_large_text_02" style="position: absolute; top:210px; right: 490px; slidedirection : bottom; slideoutdirection : bottom; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 1000;">
          {{$t('home.bannerText.tip2.h4')}}
        </h4>
        <img src="static/img/homebanner/img_wifi.png" class="ls-s3" style="position: absolute; top:240px; right: 490px; slidedirection : bottom; slideoutdirection : bottom; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInOutQuint; delayin : 1100;"/>
        <h4 class="ls-s3 l1-s1 ls_large_text_02" style="position: absolute; top:310px; right: 490px; slidedirection : bottom; slideoutdirection : bottom; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 1000;">
          {{$t('home.bannerText.tip2.h42')}}
        </h4>
      </div>
      <div class="ls-layer" style="slidedirection: top; slideoutdirection : top; slidedelay: 6000; durationin: 1500; durationout: 1500; delayout: 500;">
        <img src="static/img/homebanner/bg.png" class="ls-bg" alt="">
        <!--        <img src="static/images/slider/layer/1/-1.png" class="ls-s6" alt="" style="top: 10px; left: -15px; slidedirection : bottom; slideoutdirection : bottom; durationin : 1500; durationout : 750; easingin : easeInOutQuint; easingout : easeInOutQuint; delayin : 600;">-->
        <h1 class="ls-s3 ls_large_text_01" style="position: absolute; top:150px; right: 490px; slidedirection : top; slideoutdirection : top; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 1000;">
          {{$t('home.bannerText.tip3.h1')}}
        </h1>
        <h4 class="ls-s3 l1-s1 ls_large_text_02" style="position: absolute; top:210px; right: 490px; slidedirection : bottom; slideoutdirection : bottom; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 1000;">
          {{$t('home.bannerText.tip3.h4')}}
        </h4>
        <img src="static/img/homebanner/img_wechat.png" class="ls-s3" style="position: absolute; top:240px; right: 490px; slidedirection : bottom; slideoutdirection : bottom; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInOutQuint; delayin : 1100;"/>
        <h4 class="ls-s3 l1-s1 ls_large_text_02" style="position: absolute; top:310px; right: 490px; slidedirection : bottom; slideoutdirection : bottom; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 1000;">
          {{$t('home.bannerText.tip3.h42')}}
        </h4>
      </div>
      <!--      <div class="ls-layer" style="slidedirection: right; slideoutdirection : top; slidedelay: 5000; durationin: 1500; durationout: 1500; delayout: 500;">-->
<!--        <img src="static/img/homebanner/bg1.png" class="ls-bg" alt="">-->
<!--        <img src="static/images/slider/layer/2/_item-01.png" class="ls-s6" alt="" style="top: 15px; left: 480px; slidedirection : bottom; slideoutdirection : bottom; durationin : 1500; durationout : 750; easingin : easeInOutQuint; easingout : easeInOutQuint; delayin : 600;">-->
<!--        <h1 class="ls-s3 ls_large_text_01" style="position: absolute; font-family:Arial; top:100px; left: 0px; slidedirection : right; slideoutdirection : left; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 400;">-->
<!--          Clean Corporate Design-->
<!--        </h1>-->
<!--        <h4 class="ls-s3 l1-s1 ls_large_text_02" style="position: absolute; top:160px; left: 0px; border-color:#fff; slidedirection : bottom; slideoutdirection : left; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 500;">-->
<!--          Clean Corporate Template with some Awesome &amp; Unique Features-->
<!--        </h4>-->
<!--        <a class="button huge color round ls-s8" href="#" style="position: absolute; top:210px; left: 0px; slidedirection : bottom; slideoutdirection : bottom; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInOutQuint; delayin : 0;">Our Portfolio</a>-->
<!--      </div>-->
<!--      <div class="ls-layer" style="slidedirection: right; slideoutdirection : top; slidedelay: 5000; durationin: 1500; durationout: 1500; delayout: 500;">-->
<!--        <img src="static/images/slider/layer/3/slide3-bg.jpg" class="ls-bg" alt="">-->
<!--        <img src="static/images/slider/layer/3/slide3-pic1.png" class="ls-s6" alt="" style="top: 25px; left: 0px; slidedirection : fade; slideoutdirection : fade; durationin : 1500; durationout : 750; easingin : easeInOutQuint; easingout : easeInOutQuint; delayin : 500;">-->
<!--        <h1 class="ls-s3 ls_large_text_01" style="position: absolute; top:120px; left: 400px; slidedirection : top; slideoutdirection : top; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 600;">Fully Responsive HTML5 Template</h1>-->
<!--        <h4 class="ls-s3 l1-s1 ls_large_text_02" style="position: absolute; top:170px; left: 400px; slidedirection : bottom; slideoutdirection : bottom; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 700;">Filterable Portfolio Included, Pricing Tables and much more...</h4>-->
<!--        <a class="button huge color round ls-s8" href="#" style="position: absolute; top:210px; left: 400px; slidedirection : bottom; slideoutdirection : bottom; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInOutQuint; delayin : 800;">Pricing Tables</a>-->
<!--      </div>-->
<!--      <div class="ls-layer" style="slidedirection: top; slideoutdirection : top; slidedelay: 5000; durationin: 1500; durationout: 1500; delayout: 500;">-->
<!--        <img src="static/images/slider/layer/4/slide4-bg.jpg" class="ls-bg" alt="">-->
<!--        <img src="static/images/slider/layer/4/slider_4_man.png" class="ls-s6" alt="" style="top: 10px; left:550px; slidedirection : bottom; slideoutdirection : bottom; durationin : 1500; durationout : 750; easingin : easeInOutQuint; easingout : easeInOutQuint; delayin : 300;">-->
<!--        <h1 class="ls-s3 ls_large_text_01" style="position: absolute; top:100px; left: 0px; slidedirection : top; slideoutdirection : top; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 500;">Fullwidth &amp; Boxed Versions Included</h1>-->
<!--        <h4 class="ls-s3 l1-s1 ls_large_text_02" style="position: absolute; top:160px; left: 0px; slidedirection : bottom; slideoutdirection : bottom; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInBack; delayin : 600;">2 Layout options with more than 120 Color Combinations Available...</h4>-->
<!--        <a class="button huge color round ls-s8" href="#" style="position: absolute; top:210px; left: 0px; slidedirection : bottom; slideoutdirection : bottom; durationin : 3000; durationout : 750; easingin : easeInOutQuint; easingout : easeInOutQuint; delayin : 700;">Contact Us</a>-->
<!--      </div>-->
    </div>
    <div id="content">
      <div class="home-intro"><!-- home intro starts -->
        <div class="container">
          <div class="three-fourth">
            <h4>{{$t('home.intro.h')}}</h4>
            <p>
              {{$t('home.intro.p')}}
            </p>
          </div>
          <div class="one-fourth">
            <a href="javascript:" v-on:click="toAbout" class="button grey huge round">{{$t('home.intro.button')}}</a>
          </div>
        </div>
      </div>
      <!--home intro ends-->
      <div class="container">
        <div class="one-third margin-class">
          <div class="feature-block"><!-- features blocks starts -->
            <div class="feature-block-title">
              <div class="feature-block-icon">
                <i class="icon-home-ic_phone iIconCorrect"></i><span class="spanIconCorrect"></span>
              </div>
              <h4>{{$t('home.devType.tip1.title')}}</h4>
              <h6>{{$t('home.devType.tip1.subtitle')}}</h6>
            </div>
            <p>
              {{$t('home.devType.tip1.content')}}
            </p>
          </div>
        </div>

        <div class="one-third margin-class">
          <div class="feature-block">
            <div class="feature-block-title">
              <div class="feature-block-icon">
                <i class="icon-home-ic_android iIconCorrect"></i><span class="spanIconCorrect"></span>
              </div>
              <h4>{{$t('home.devType.tip2.title')}}</h4>
              <h6>{{$t('home.devType.tip2.subtitle')}}</h6>
            </div>
            <p>
              {{$t('home.devType.tip2.content')}}
            </p>
          </div>
        </div>
        <div class="one-third margin-class">
          <div class="feature-block">
            <div class="feature-block-title">
              <div class="feature-block-icon">
                <i class="icon-home-ic_server iIconCorrect"></i><span class="spanIconCorrect"></span>
              </div>
              <h4>{{$t('home.devType.tip3.title')}}</h4>
              <h6>{{$t('home.devType.tip3.subtitle')}}</h6>
            </div>
            <p>
              {{$t('home.devType.tip3.content')}}
            </p>
          </div>
        </div><!--features block ends-->
        <div class="one-third margin-class">
          <div class="feature-block">
            <div class="feature-block-title">
              <div class="feature-block-icon">
                <i class="icon-home-ic_bt iIconCorrect"></i><span class="spanIconCorrect"></span>
              </div>
              <h4>{{$t('home.devType.tip4.title')}}</h4>
              <h6>{{$t('home.devType.tip4.subtitle')}}</h6>
            </div>
            <p>
              {{$t('home.devType.tip4.content')}}
            </p>
          </div>
        </div><!--features block ends-->
        <div class="one-third margin-class">
          <div class="feature-block">
            <div class="feature-block-title">
              <div class="feature-block-icon">
                <i class="icon-home-ic_wifi iIconCorrect"></i><span class="spanIconCorrect"></span>
              </div>
              <h4>{{$t('home.devType.tip5.title')}}</h4>
              <h6>{{$t('home.devType.tip5.subtitle')}}</h6>
            </div>
            <p>
              {{$t('home.devType.tip5.content')}}
            </p>
          </div>
        </div><!--features block ends-->
        <div class="one-third margin-class">
          <div class="feature-block">
            <div class="feature-block-title">
              <div class="feature-block-icon">
                <i class="icon-home-ic_wechat iIconCorrect"></i><span class="spanIconCorrect"></span>
              </div>
              <h4>{{$t('home.devType.tip6.title')}}</h4>
              <h6>{{$t('home.devType.tip6.subtitle')}}</h6>
            </div>
          </div>
          <p>
            {{$t('home.devType.tip6.content')}}
          </p>
        </div><!--features block ends-->
      </div>
      <div class="intro-features"><!-- intro features panel starts -->
        <Case v-on:change-case="changeCase"></Case>
<!--        <div class="container">-->
<!--          <h4>{{$t('home.productCase.title')}}</h4>-->
<!--          <div class="slidewrap">-->
<!--            &lt;!&ndash;project carousel starts&ndash;&gt;-->
<!--            <ul class="slider" id="sliderName">-->
<!--              <li class="slide">&lt;!&ndash; carousel item starts &ndash;&gt;-->
<!--                <div class="one-fourth">-->
<!--                  <div class="item-wrapp">-->
<!--                    <div class="portfolio-item">-->
<!--                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>-->
<!--                      <img src="static/img/productCase/img_iot.png" alt=""/>-->
<!--                    </div>-->
<!--                    <div class="portfolio-item-title">-->
<!--                      <a href="#">{{$t('home.productCase.tip1.title')}}</a>-->
<!--                      <p>-->
<!--                        {{$t('home.productCase.tip1.subtitle')}}-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="one-fourth">-->
<!--                  <div class="item-wrapp">-->
<!--                    <div class="portfolio-item">-->
<!--                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>-->
<!--                      <img src="static/img/productCase/img_anker.png" alt=""/>-->
<!--                    </div>-->
<!--                    <div class="portfolio-item-title">-->
<!--                      <a href="#">{{$t('home.productCase.tip2.title')}}</a>-->
<!--                      <p>-->
<!--                        {{$t('home.productCase.tip2.subtitle')}}-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="one-fourth">-->
<!--                  <div class="item-wrapp">-->
<!--                    <div class="portfolio-item">-->
<!--                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>-->
<!--                      <img src="static/img/productCase/img_anker_1.png" alt=""/>-->
<!--                    </div>-->
<!--                    <div class="portfolio-item-title">-->
<!--                      <a href="#">{{$t('home.productCase.tip3.title')}}</a>-->
<!--                      <p>-->
<!--                        {{$t('home.productCase.tip3.subtitle')}}-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="one-fourth">-->
<!--                  <div class="item-wrapp">-->
<!--                    <div class="portfolio-item">-->
<!--                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>-->
<!--                      <img src="static/img/productCase/img_translate.png" alt=""/>-->
<!--                    </div>-->
<!--                    <div class="portfolio-item-title">-->
<!--                      <a href="#">{{$t('home.productCase.tip4.title')}}</a>-->
<!--                      <p>-->
<!--                        {{$t('home.productCase.tip4.subtitle')}}-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </li>-->
<!--              <li class="slide">&lt;!&ndash; carousel item starts &ndash;&gt;-->
<!--&lt;!&ndash;                <div class="one-fourth">&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="item-wrapp">&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="portfolio-item">&ndash;&gt;-->
<!--&lt;!&ndash;                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                      <a href="static/images/portfolio/portfolio-item-1.jpg" data-rel="prettyPhoto" class="item-preview"><i class="icon-zoom-in"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                      <img src="static/images/portfolio/portfolio-item-1.jpg" alt=""/>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="portfolio-item-title">&ndash;&gt;-->
<!--&lt;!&ndash;                      <a href="single-project-small.html">Joomla Templates</a>&ndash;&gt;-->
<!--&lt;!&ndash;                      <p>&ndash;&gt;-->
<!--&lt;!&ndash;                        Design / Development&ndash;&gt;-->
<!--&lt;!&ndash;                      </p>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                <div class="one-fourth">&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="item-wrapp">&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="portfolio-item">&ndash;&gt;-->
<!--&lt;!&ndash;                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                      <a href="static/images/portfolio/portfolio-item-1.jpg" data-rel="prettyPhoto" class="item-preview"><i class="icon-zoom-in"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                      <img src="static/images/portfolio/portfolio-item-1.jpg" alt=""/>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="portfolio-item-title">&ndash;&gt;-->
<!--&lt;!&ndash;                      <a href="single-project-small.html">晓言智屏音箱</a>&ndash;&gt;-->
<!--&lt;!&ndash;                      <p>&ndash;&gt;-->
<!--&lt;!&ndash;                        Design / Development&ndash;&gt;-->
<!--&lt;!&ndash;                      </p>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                <div class="one-fourth">&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="item-wrapp">&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="portfolio-item">&ndash;&gt;-->
<!--&lt;!&ndash;                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                      <a href="static/images/portfolio/portfolio-item-1.jpg" data-rel="prettyPhoto" class="item-preview"><i class="icon-zoom-in"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                      <img src="static/images/portfolio/portfolio-item-1.jpg" alt=""/>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="portfolio-item-title">&ndash;&gt;-->
<!--&lt;!&ndash;                      <a href="single-project-small.html">Font Design</a>&ndash;&gt;-->
<!--&lt;!&ndash;                      <p>&ndash;&gt;-->
<!--&lt;!&ndash;                        Design / Development&ndash;&gt;-->
<!--&lt;!&ndash;                      </p>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                <div class="one-fourth">&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="item-wrapp">&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="portfolio-item">&ndash;&gt;-->
<!--&lt;!&ndash;                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                      <a href="static/images/portfolio/portfolio-item-1.jpg" data-rel="prettyPhoto" class="item-preview"><i class="icon-zoom-in"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                      <img src="static/images/portfolio/portfolio-item-1.jpg" alt=""/>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="portfolio-item-title">&ndash;&gt;-->
<!--&lt;!&ndash;                      <a href="single-project-small.html">Custom Drupal Theme</a>&ndash;&gt;-->
<!--&lt;!&ndash;                      <p>&ndash;&gt;-->
<!--&lt;!&ndash;                        Design / Development&ndash;&gt;-->
<!--&lt;!&ndash;                      </p>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--              </li>-->
<!--            </ul>&lt;!&ndash; carousel items UL ends &ndash;&gt;-->
<!--            <ul class="slidecontrols">-->
<!--              <li><a href="#sliderName" class="prev">Prev</a></li>-->
<!--              <li><a href="#sliderName" class="next">Next</a></li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
      </div><!-- intro features panel ends -->
      <div class=" clients-wrapp">
        <div class="container">
          <ul class="client-block">
            <li>
                <div class="one-fifth">
                  <a href="#" class="tooltip" ><img src="static/img/clients/AppleTV2.png" alt=""/></a>
                </div>
                <div class="one-fifth">
                  <a href="#" class="tooltip" ><img src="static/img/clients/AppleTV2_3.png" alt=""/></a>
                </div>
                <div class="one-fifth">
                  <a href="#" class="tooltip" ><img src="static/img/clients/AppleTV2_2.png" alt=""/></a>
                </div>
                <div class="one-fifth">
                  <a href="#" class="tooltip" ><img src="static/img/clients/AppleTV2_1.png" alt=""/></a>
                </div>
                <div class="one-fifth">
                  <a href="#" class="tooltip" ><img src="static/img/clients/AppleTV2_4.png" alt=""/></a>
                </div>
              </li>
<!--            <li>-->
<!--                <div class="one-fifth">-->
<!--                  <a href="#" class="tooltip" title="Some Clients Name"><img src="static/images/clients/client-6.png" alt=""/></a>-->
<!--                </div>-->
<!--                <div class="one-fifth">-->
<!--                  <a href="#" class="tooltip" title="Some Clients Name"><img src="static/images/clients/client-5.png" alt=""/></a>-->
<!--                </div>-->
<!--                <div class="one-fifth">-->
<!--                  <a href="#" class="tooltip" title="Some Clients Name"><img src="static/images/clients/client-4.png" alt=""/></a>-->
<!--                </div>-->
<!--                <div class="one-fifth">-->
<!--                  <a href="#" class="tooltip" title="Some Clients Name"><img src="static/images/clients/client-3.png" alt=""/></a>-->
<!--                </div>-->
<!--                <div class="one-fifth">-->
<!--                  <a href="#" class="tooltip" title="Some Clients Name"><img src="static/images/clients/client-2.png" alt=""/></a>-->
<!--                </div>-->
<!--              </li>-->
          </ul>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>

</template>

<script>
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'
import Case from '@/components/common/Case'

const HeaderCheck = {
  tip1: 'current',
  tip2: '',
  tip3: '',
  tip4: '',
  tip5: ''
}
export default {
  name: 'Home',
  components: {Footer, Header, Case},
  data: function () {
    return {
      HeaderCheck: HeaderCheck
    }
  },
  methods: {
    changeCase: function (data) {
      const router = this.$router
      router.push({ path: 'product/' + data.name })
      // router.go(0)
      window.location.reload()
      window.scrollTo(0, 0)
    },
    toAbout () {
      const router = this.$router
      // this.reload()
      // router.go(0)
      router.push({ name: 'aboutTeam' })
      // router.go(0)
      window.location.reload()
      window.scrollTo(0, 0)
    }
  },
  activated () {
    // this.$router.go(0)
    window.location.reload()
  },
  inject: ['reload'],
  watch: {
    // 检测路由参数发生改变时，刷新当前页面 调用
    '$route': function () {
      this.reload()
    }
  }
}
</script>

<style scoped>
.spanIconCorrect{
  margin-top: -42px;
}
.iIconCorrect{
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-left: -10px;
  font-size: 3em;
  line-height: 20px;
}
.ls-layer{
  cursor: pointer;
}
.ls_large_text_01{
  color: white !important;
}
.ls_large_text_02{
  color: #EEEEEE;
  font-style: normal;
}
.margin-class{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/Home.vue